import { get } from 'lodash';
import * as types from '../actions/actionTypes';

export const browserStorage = (state = {}, action) => {
  switch (action.type) {
    case types.SET_BROWSER_STORAGE_ITEM: {
      const { payload, meta } = action;
      const fingerprint = get(meta, 'fingerprint');
      if (fingerprint) {
        return {
          ...state,
          [fingerprint]: {
            ...get(state, fingerprint, {}),
            ...payload,
          },
        };
      }
      return state;
    }
    case types.CLEAR_BROWSER_STORAGE_ITEM: {
      const { meta } = action;
      const fingerprint = get(meta, 'fingerprint');
      if (fingerprint) {
        const { [fingerprint]: removedKey, ...nextState } = state;
        return {
          ...nextState,
        };
      }
      return state;
    }
    case types.GET_BROWSER_STORAGE_ITEMS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
